module.exports = __webpack_public_path__ + "img/Mover_Back_Side_Right.59b76e1b.svg";